import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LOADING_STATUS } from '../../../shared/constants/loadingStatus';
import { useApiReady } from '../../../shared/hooks';
import { CAMPAIGN_CADENCES_TYPE_TAB_KEY } from '../constants/campaignCadencesTabs';
import {
  campaignCadencesCampaignSelected,
  selectCampaignCadencesCampaigns,
  selectCampaignCadencesCampaignsStatus,
  selectCampaignCadencesSelectedCampaignId,
  selectCampaignCadencesSelectedChannel,
  selectCampaignCadencesSelectedTypeTab,
} from '../store/campaignCadencesSlice';
import {
  loadCampaignCadenceCampaigns,
  loadCampaignCadenceContent,
} from '../store/campaignCadencesThunks';

export function useCampaignCadencesData() {
  const dispatch = useDispatch();
  const apiReady = useApiReady();

  const campaigns = useSelector(selectCampaignCadencesCampaigns);
  const campaignsStatus = useSelector(selectCampaignCadencesCampaignsStatus);
  const selectedCampaignId = useSelector(selectCampaignCadencesSelectedCampaignId);
  const selectedChannel = useSelector(selectCampaignCadencesSelectedChannel);
  const selectedTypeTab = useSelector(selectCampaignCadencesSelectedTypeTab);
  const isTriggersTab = selectedTypeTab === CAMPAIGN_CADENCES_TYPE_TAB_KEY.TRIGGERS;

  useEffect(() => {
    if (apiReady && campaignsStatus === LOADING_STATUS.IDLE) {
      dispatch(loadCampaignCadenceCampaigns());
    }
  }, [apiReady, dispatch, campaignsStatus]);

  useEffect(() => {
    if (
      campaigns.length > 0 &&
      selectedCampaignId == null &&
      campaignsStatus === LOADING_STATUS.SUCCEEDED
    ) {
      dispatch(campaignCadencesCampaignSelected(campaigns[0].id));
    }
  }, [dispatch, campaigns, selectedCampaignId, campaignsStatus]);

  useEffect(() => {
    if (isTriggersTab) {
      dispatch(loadCampaignCadenceContent({ typeTab: selectedTypeTab, channel: selectedChannel }));
      return;
    }
    if (selectedCampaignId != null) {
      dispatch(
        loadCampaignCadenceContent({
          typeTab: selectedTypeTab,
          campaignId: selectedCampaignId,
          channel: selectedChannel,
        }),
      );
    }
  }, [dispatch, isTriggersTab, selectedTypeTab, selectedCampaignId, selectedChannel]);
}
